// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;
export const CHAT_DRAWER_WIDTH = 380;
/** CSS width for chat panel — scales with viewport, capped for readability */
export const CHAT_DRAWER_WIDTH_CSS = 'clamp(280px, 28vw, 400px)';

const config = {
  fontFamily: `'Public Sans', sans-serif`
};

export default config;
